"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.partnerEmulationInitWatcher = partnerEmulationInitWatcher;

var _effects = require("redux-saga/effects");

var filterActions = _interopRequireWildcard(require("../filters/value/actions"));

var _selectors = require("./selectors");

var _filters = require("../../constants/filters");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(partnerEmulationInit),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(partnerEmulationInitWatcher);

function partnerEmulationInit() {
  var emulationPartnerId;
  return regeneratorRuntime.wrap(function partnerEmulationInit$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_selectors.getEmulationPartnerId);

        case 2:
          emulationPartnerId = _context.sent;
          _context.next = 5;
          return (0, _effects.put)(filterActions.setField(_filters.FILTER_TYPE.HEADER_FILTER, _filters.FILTER_FIELD.PARTNER_EMULATION_ID, emulationPartnerId));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function partnerEmulationInitWatcher() {
  return regeneratorRuntime.wrap(function partnerEmulationInitWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)('persist/REHYDRATE', partnerEmulationInit);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}